"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyAdUpdateSchema = exports.AppleProxyAdListResponseSchema = exports.AppleProxyCampaignAdGroupAdRefParamsSchema = exports.AppleProxyAdResponseSchema = exports.AppleProxyAdCreateSchema = exports.AppleProxyAdListSchema = exports.AppleProxyAdSchema = exports.AppleProxyAdStatusSchema = exports.AppleProxyAdServingStatusSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const core_2 = require("./core");
const creatives_1 = require("./creatives");
exports.AppleProxyAdServingStatusSchema = (0, core_1.StringUnion)([
    "RUNNING",
    "NOT_RUNNING",
]);
exports.AppleProxyAdStatusSchema = (0, core_1.StringUnion)(["ENABLED", "PAUSED"]);
const AppleProxyAdProperties = {
    adGroupId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    campaignId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    creationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema),
    creativeId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    creativeType: (0, core_1.OptionalNullable)(creatives_1.AppleProxyCreativeTypeSchema),
    deleted: (0, core_1.OptionalNullable)(typebox_1.Type.Boolean()),
    id: (0, core_1.OptionalNullable)(ruby_1.AppleProxyRefSchema),
    modificationTime: (0, core_1.OptionalNullable)(core_2.AppleProxyDateTimeSchema),
    name: (0, core_1.OptionalNullable)(typebox_1.Type.String()),
    orgId: (0, core_1.OptionalNullable)(ruby_1.AppleProxyOrgRefSchema),
    servingStateReasons: (0, core_1.OptionalNullable)(typebox_1.Type.Array(typebox_1.Type.String())),
    servingStatus: (0, core_1.OptionalNullable)(exports.AppleProxyAdServingStatusSchema),
    status: (0, core_1.OptionalNullable)(exports.AppleProxyAdStatusSchema),
};
exports.AppleProxyAdSchema = typebox_1.Type.Object({ ...AppleProxyAdProperties });
exports.AppleProxyAdListSchema = typebox_1.Type.Array(exports.AppleProxyAdSchema);
/**
 * API types
 */
exports.AppleProxyAdCreateSchema = typebox_1.Type.Object({
    ...AppleProxyAdProperties,
});
exports.AppleProxyAdResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(exports.AppleProxyAdSchema),
});
exports.AppleProxyCampaignAdGroupAdRefParamsSchema = (0, core_1.StrictObject)({
    adId: ruby_1.AppleProxyRefSchema,
    adGroupId: ruby_1.AppleProxyRefSchema,
    campaignId: ruby_1.AppleProxyRefSchema,
});
exports.AppleProxyAdListResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(exports.AppleProxyAdListSchema),
    pagination: (0, core_1.OptionalNullable)(core_2.AppleProxyPageDetailSchema),
});
exports.AppleProxyAdUpdateSchema = typebox_1.Type.Object({
    ...AppleProxyAdProperties,
});
